export const ATTENDANCE = "DESIGNATION";
export const ATTENDANCE_SUCCESS = "ATTENDANCE_SUCCESS";
export const ATTENDANCE_FAILED = "ATTENDANCE_FAILED";

export const ADD_ATTENDANCE = "ADD_ATTENDANCE";
export const ADD_ATTENDANCE_SUCCESS = "ADD_ATTENDANCE_SUCCESS";
export const ADD_ATTENDANCE_FAILED = "ADD_ATTENDANCE_FAILED";

export const UPDATE_ATTENDANCE = "UPDATE_ATTENDANCE";
export const UPDATE_ATTENDANCE_SUCCESS = "UPDATE_ATTENDANCE_SUCCESS";
export const UPDATE_ATTENDANCE_FAILED = "UPDATE_ATTENDANCE_FAILED";